( function ( $ ) {

	$( '.reviews__item__read' ).on( 'click', function( event ){
		event.preventDefault();
		const review = $( this ).attr( 'href' );
		$( review ).fadeIn( 300 );
	} );

	$( '.reviews__item__bg' ).on( 'click', function( event ) {
		event.stopPropagation();
		if ( $( event.target ).closest( '.reviews__item--full' ).length ) {
			return;
		}
		$( this ).fadeOut( 300 );
	} );

	$( '.reviews__item__close' ).on( 'click', function( event ) {
		event.stopPropagation();
		$( this ).closest( '.reviews__item__bg' ).fadeOut( 300 );
	} );

	if ( $( '.reviews__list' ).length ) {
		$( '.reviews__list' ).owlCarousel( {
			loop: false,
			margin: 0,
			nav: true,
			dots: false,
			navContainer: '.reviews__txt__controls',
			smartSpeed: 700,
			autoplay: false,
			navText: [
				'<span class="fa fa-angle-left"></span>',
				'<span class="fa fa-angle-right"></span>',
			],
			responsive: {
				0: {
					items: 1,
				},
				992: {
					items: 3,
				},
			},
		} );
	}

	if ( $( '.reviews__video__list' ).length ) {
		$( '.reviews__video__list' ).owlCarousel( {
			loop: false,
			margin: 0,
			nav: true,
			dots: false,
			navContainer: '.reviews__video__controls',
			smartSpeed: 700,
			autoplay: false,
			navText: [
				'<span class="fa fa-angle-left"></span>',
				'<span class="fa fa-angle-right"></span>',
			],
			responsive: {
				0: {
					items: 1,
				},
				992: {
					items: 3,
				},
			},
		} );
	}
} )( jQuery );
